import projectRoutingKeys from "Areas/Projects/routingKeys";
import { routesAndPagesMap } from "Common/routingUtils";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getDraft, getHasChanges, getProjectId } from "../redux/selectors";
import ProjectEditor from "./projectEditor";
const mapStateToProps = (state) => ({
    draft: getDraft(state),
    projectId: getProjectId(state),
    hasChanges: getHasChanges(state)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
    onSaveProject: (project) => {
        ownProps.onEditingInProgress && ownProps.onEditingInProgress(true, project.Id);
        Promise.resolve(dispatch(actionCreators.saveProject(project))).then((promiseResult) => {
            var _a;
            ownProps.onEditingInProgress && ownProps.onEditingInProgress(false, project.Id);
            if (((_a = promiseResult === null || promiseResult === void 0 ? void 0 : promiseResult.response) === null || _a === void 0 ? void 0 : _a.Id) === undefined)
                return;
            ownProps.onHide && ownProps.onHide(project.Id);
            const href = routesAndPagesMap.getPath(projectRoutingKeys.PROJECT_DETAILS, promiseResult.response.Id);
            if (href && href !== window.location.href)
                window.location.href = href;
        });
    },
    onSetDraft: (draft) => {
        dispatch(actionCreators.setDraft(draft));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(ProjectEditor);
